(function ($) {
    jQuery(document).ready(function () {
        jQuery("#portfolio_industry,#portfolio_technology").change(function() {            
            var industry_value = jQuery('#portfolio_industry').val();   
            var technology_value = jQuery('#portfolio_technology').val();          
            var portfolio_url = window.location.href.replace(/\?.*$/, '') + '?technology=' + technology_value + '&industry=' + industry_value;
            window.location = portfolio_url;
        });

        jQuery("#reset_portfolio_filter").click(function(){
            var without_filter_url = window.location.href.replace(/\?.*$/, '');
            window.location = without_filter_url;
        });

    });
})(jQuery);


// WEBPACK FOOTER //
// ./scripts/portfolio/script.js